import TreeViewListConfigured from "./treeViewConfigured";

export default TreeViewListConfigured;
